<script>
import { mapState } from 'pinia';

import { useUserStore } from '../../../store/useUserStore.js';

export default {
  name: 'CpSearcherCard',
  components: {
    CpButtonLink: require('../button-link').default,
    handleImageError: require('../mixins/utils').default,
    LobbyActionButton: require('../social-feed/actions/lobby-action-button').default,
    CpLobbyAction: require('../lawmaker/components/LobbyAction.vue').default,
    CpDialogAuthForm: require('../auth-form/dialog-auth-form').default,
  },
  directives: {
    margin: require('../directives/margins').margin,
    marginBottom: require('../directives/margins').marginBottom,
    marginRight: require('../directives/margins').marginRight,
  },
  props: {
    politician: {
      type: Object,
      default: () => ({}),
    },
  },
  data() {
    return {
      showLobbyDialog: false,
      showAuthModal: false,
      isStartingLobby: false,
    };
  },
  computed: {
    ...mapState(useUserStore, ['isUserLogin', 'userProfileData']),
  },
  methods: {
    redirectToOfficial() {
      window.location.href = `officials/${this.politician.id}`;
    },
  },
};
</script>

<template>
  <div class="searcher-card-container">
    <div class="searcher-card-content">
      <span class="circle-container" v-margin-right="1">
        <img :src="`${politician.large_img}`" alt="Official's image" @error="handleImageError" loading="lazy"
      /></span>
      <div>
        <h3 class="subheadline1 black-color politician-name" v-margin-bottom="0" @click="redirectToOfficial()">{{ politician.full_name }}</h3>
        <p class="body1 black-color">{{ politician.office_name }}</p>
      </div>
    </div>
    <div class="lobby-action-container">
      <CpLobbyAction :politician="politician" />
    </div>
  </div>
</template>

<style scoped>
.searcher-card-container,
.lobby-action-button {
  border-radius: 6px;
  background-color: var(--white);
}
.searcher-card-container {
  display: flex;
  justify-content: space-between;
  padding: 16px;
  border: 1px solid var(--neutral3);
}
.searcher-card-content {
  display: flex;
  align-items: center;
}
.lobby-action-button {
  border: 1px solid var(--primary);
}
.circle-container {
  width: 90px;
  height: 90px;
  border-radius: 50%;
  overflow: hidden;
  display: flex;
  align-items: center;
  justify-content: center;
}
.circle-container img {
  width: 100%;
  height: 100%;
  object-fit: cover;
}
.politician-name {
  text-decoration: underline;
  cursor: pointer;
}
.lobby-action-container {
  display: flex;
  align-items: center;
}
@media only screen and (max-width: 768px) {
  .searcher-card-container {
    flex-direction: column;
  }
  .lobby-action-container {
    justify-content: center;
  }
  .circle-container {
    width: 50px;
    height: 50px;
  }
}
</style>
